import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Dialog, 
  DialogContent, 
  Select,
  MenuItem,
  Menu,
  FormControl,
  Step, 
  Stepper,
  StepLabel,
  DialogActions,
  Stack, 
  Alert,
  IconButton,
  Tooltip,
  ListItemIcon
} from '@mui/material';
// ADD
import {
  LEVELS,
  SUBJECTS,
  STAGES,
  LANG_MODULES,
  LANG_LEVELS,
  HIGH_STREAMS
} from '../../constants.js';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { collection, addDoc, query, where, getDocs } from 'firebase/firestore';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../../firebaseConfig.js'; 
import HeroImg from '../../img/HeroImg.png';
import HowItWorksImg from '../../img/HowItWorks.png';
import logo from '../../img/logo.png';
import ArabicFlag from "../../img/Arabic_flag.png";
import FrenchFlag from "../../img/French_flag.png";
import EnglishFlag from "../../img/English_flag.png";
import ticket1 from '../../img/ticket1.jpg';
import shortLogo from '../../img/shortLogo.png';
import { useTranslation } from 'react-i18next';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import LibraryBooksRoundedIcon from '@mui/icons-material/LibraryBooksRounded';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import TranslateRoundedIcon from '@mui/icons-material/TranslateRounded';
import PersonAddAlt1RoundedIcon from '@mui/icons-material/PersonAddAlt1Rounded';
import HowToRegRoundedIcon from '@mui/icons-material/HowToRegRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';

const LANGS = [
  { code: "ar", labelKey: "landing.lang.ar", flagImg: ArabicFlag },
  { code: "fr", labelKey: "landing.lang.fr", flagImg: FrenchFlag },
  { code: "en", labelKey: "landing.lang.en", flagImg: EnglishFlag },
];

function resolveApiBaseUrl() {
  return String(
    process.env.REACT_APP_API_BASE_URL ||
      "https://us-central1-houari-boumedienne-schoo-4d4c2.cloudfunctions.net",
  ).replace(/\/+$/, "");
}

function LandingPage() {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir(i18n.resolvedLanguage || i18n.language || "ar") === "rtl";
  const pageDirection = isRtl ? "rtl" : "ltr";
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    enrollments: [],
    adminValidated: false,
    fullyRegistered: false,
    entryDate: new Date().toISOString()
  });

  //const [confirmEmail, setConfirmEmail] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [langAnchorEl, setLangAnchorEl] = useState(null);
  const [navAnchorEl, setNavAnchorEl] = useState(null);
  const [activeHeroNav, setActiveHeroNav] = useState('benefits');
  const [activeFaq, setActiveFaq] = useState(0);
  const [heroEntered, setHeroEntered] = useState(false);
  const [offersInView, setOffersInView] = useState(false);
  const [howInView, setHowInView] = useState(false);
  const [faqInView, setFaqInView] = useState(false);
  const [pricingInView, setPricingInView] = useState(false);
  const [programType, setProgramType] = useState(' إختر هدفك التعليمي');
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isTutorJoinModalOpen, setIsTutorJoinModalOpen] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null); 
  const [tutorJoinData, setTutorJoinData] = useState({
    fullName: '',
    tutorType: 'Teacher',
    socialPlatform: 'Instagram',
    followersCount: '',
    whatsappPhone: '',
    email: '',
  });
  const [tutorJoinError, setTutorJoinError] = useState('');
  const [tutorJoinSuccess, setTutorJoinSuccess] = useState('');
  const [tutorJoinSubmitting, setTutorJoinSubmitting] = useState(false);
  // Wizard control
  const [step, setStep] = useState(1);
  const steps = [t('الاختيار'), t('البيانات الشخصية'), t('الدفع'), t('التأكيد')];
  const activeIndex = steps.length - step; 

  // ---- Branch A: مستويات اللغات ----
  const [langCategory, setLangCategory] = useState(''); // أطفال | مراهقون | كبار
  const [language, setLanguage] = useState('');         // الإنجليزية | الفرنسية | ...
  const [level, setLevel] = useState('');               // 1..12

  // ---- Branch B: المواد الدراسية ----
  const [schoolStage, setSchoolStage] = useState('');   // ابتدائي | متوسط | ثانوي
  const [highStream, setHighStream] = useState('');     // شعبة للثانوي (optional)
  const [schoolYear, setSchoolYear] = useState('');     // 1,2,3...
  const [subjectsChosen, setSubjectsChosen] = useState([]); // multiple

  // ---- Payment (both branches) ----
  const [paymentMethod, setPaymentMethod] = useState('');  // 'ccp' | 'cash'
  const [ccpNumber, setCcpNumber] = useState('12345678900'); // fixed display or from config
  const [paymentFile, setPaymentFile] = useState(null);

  // ADD — derived option lists for the academic branch
  const [availableYears, setAvailableYears] = useState([]);
  const [availableHighBranches, setAvailableHighBranches] = useState([]);
  const [availableSubjects, setAvailableSubjects] = useState([]);
  // Fallback list (will be used if HIGH_STREAMS is undefined)
  const FALLBACK_HIGH_STREAMS = ['لغات أجنبية', 'آداب', 'علوم'];

  const benefitsRef = useRef(null);
  const howRef = useRef(null);
  const faqRef = useRef(null);
  const pricingRef = useRef(null);
  const currentLang = LANGS.find((l) => l.code === (i18n.language || "ar")) || LANGS[0];
  const heroNavItems = [
    { key: 'benefits', label: t('landing.nav.benefits'), targetId: 'benefits-section' },
    { key: 'how', label: t('landing.nav.howItWorks'), targetId: 'how-section' },
    { key: 'faqs', label: t('landing.nav.faqs'), targetId: 'faq-section' },
  ];

  const handleLangMenuOpen = (event) => {
    setLangAnchorEl(event.currentTarget);
  };

  const handleLangMenuClose = () => {
    setLangAnchorEl(null);
  };

  const handleNavMenuOpen = (event) => {
    setNavAnchorEl(event.currentTarget);
  };

  const handleNavMenuClose = () => {
    setNavAnchorEl(null);
  };

  const handleSelectLanguage = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem("darssy_lang", code);
    handleLangMenuClose();
  };

  const handleHeroNavClick = (itemKey, targetId) => {
    setActiveHeroNav(itemKey);
    const scrollToTarget = () => {
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    if (navAnchorEl) {
      handleNavMenuClose();
      // Wait for Menu to close and release scroll lock on mobile.
      setTimeout(scrollToTarget, 140);
      return;
    }

    scrollToTarget();
  };


  // Students info
  const [fieldErrors, setFieldErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });


  // ——— Validators (component scope) ———
  const emailRegex  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validatePersonalStep = React.useCallback(() => {
    const errs = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    };

    const fn = (formData.firstName || '').trim();
    const ln = (formData.lastName  || '').trim();
    const em = (formData.email     || '').trim();
    const ph = (formData.phone     || '').trim();

    if (!fn) errs.firstName = t('الاسم مطلوب');
    if (!ln) errs.lastName  = t('اللقب مطلوب');
    if (!emailRegex.test(em))  errs.email     = t('الرجاء إدخال بريد إلكتروني صحيح');
    if (!ph) errs.phone = t('رقم الهاتف مطلوب');

    setFieldErrors(errs);
    return Object.values(errs).every((v) => !v);
  }, [formData.firstName, formData.lastName, formData.email, formData.phone]);


  // ADD — map (stage/year/branch) -> the exact LEVEL label used in SUBJECTS
  const computeAcademicLevelLabel = React.useCallback(() => {
    if (schoolStage === 'ابتدائي' || schoolStage === 'متوسط') {
      if (!schoolYear) return '';
      return `${schoolYear} ${schoolStage}`; // e.g., "3 ابتدائي", "2 متوسط"
    }

    if (schoolStage === 'ثانوي') {
      if (schoolYear === '1') {
        if (!highStream) return '';
        return highStream === 'جذع مشترك آداب'
          ? '1ere annee (جذع مشترك آداب)'
          : '1ere annee (جذع مشترك علوم وتكنولوجيا)';
      }

      const map2 = {
        'علوم تجريبية': {
          '2': '2eme annee (علوم تجريبية)',
          '3': '3eme annee (علوم تجريبية)',
        },
        'رياضيات': {
          '2': '2eme annee (رياضيات)',
          '3': '3eme annee (رياضيات)',
        },
        'تقني رياضي': {
          '2': '2eme annee (تقني رياضي)',
          '3': '3eme annee (تقني رياضي)',
        },
        'تسيير واقتصاد': {
          '2': '2eme annee (تسيير واقتصاد)',
          '3': '3eme annee (تسيير واقتصاد)',
        },
        'آداب وفلسفة': {
          '2': '2eme annee (آداب وفلسفة)',
          '3': '3eme annee (آداب وفلسفة)',
        },
        'لغات أجنبية': {
          '2': '2eme annee (لغات أجنبية)',
          '3': '3eme annee (لغات أجنبية)',
        },
      };

      if (!highStream || !schoolYear) return '';
      return map2[highStream]?.[schoolYear] || '';
    }

    return '';
  }, [schoolStage, schoolYear, highStream]);

  // Simple price example (replace with your real logic)
  const computePrice = () => {
    if (selectedProgram === 'languages') {
      return level ? 3000 + Number(level) * 500 : 0; // demo calc
    } else {
      return subjectsChosen.length * 2500; // demo per-subject
    }
  };

  const next = () => setStep((s) => Math.min(4, s + 1));
  const back = () => setStep((s) => Math.max(1, s - 1));


  const openFormModal = (program) => {
    setSelectedProgram(program);
    setIsFormModalOpen(true);
  };

  const closeFormModal = () => {
    setIsFormModalOpen(false);
    setSelectedProgram(null);
  };

  const openTutorJoinModal = () => {
    setTutorJoinError('');
    setTutorJoinSuccess('');
    setIsTutorJoinModalOpen(true);
  };

  const handleOpenTutorJoinCta = (event) => {
    if (event?.preventDefault) event.preventDefault();
    if (event?.stopPropagation) event.stopPropagation();
    setTutorJoinError('');
    setTutorJoinSuccess('');
    setIsTutorJoinModalOpen(true);
  };

  const closeTutorJoinModal = () => {
    setIsTutorJoinModalOpen(false);
    setTutorJoinError('');
    setTutorJoinSuccess('');
    setTutorJoinSubmitting(false);
  };

  const handleTutorJoinChange = (field) => (event) => {
    const value = event.target.value;
    setTutorJoinData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleTutorJoinSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+\d[\d\s-]{6,20}$/;

    if (!tutorJoinData.fullName.trim()) {
      setTutorJoinError('Please enter your full name.');
      return;
    }
    if (!tutorJoinData.whatsappPhone.trim()) {
      setTutorJoinError('Please enter your WhatsApp phone number with country code.');
      return;
    }
    if (!phoneRegex.test(tutorJoinData.whatsappPhone.trim())) {
      setTutorJoinError('WhatsApp number must start with + country code (example: +213550265689).');
      return;
    }
    if (!tutorJoinData.email.trim()) {
      setTutorJoinError('Please enter your email address.');
      return;
    }
    if (!emailRegex.test(tutorJoinData.email.trim())) {
      setTutorJoinError('Please enter a valid email address.');
      return;
    }
    if (!String(tutorJoinData.followersCount).trim()) {
      setTutorJoinError('Please enter your follower count.');
      return;
    }
    const followers = Number(tutorJoinData.followersCount);
    if (!Number.isFinite(followers) || followers < 0) {
      setTutorJoinError('Please enter a valid follower count.');
      return;
    }

    setTutorJoinError('');
    setTutorJoinSuccess('');
    setTutorJoinSubmitting(true);
    try {
      const endpoint = `${resolveApiBaseUrl()}/api/tutor-applications/submit`;
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: tutorJoinData.fullName.trim(),
          tutorType: tutorJoinData.tutorType,
          socialPlatform: tutorJoinData.socialPlatform,
          whatsappPhone: tutorJoinData.whatsappPhone.trim(),
          email: tutorJoinData.email.trim(),
          followersCount: followers,
        }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload?.ok) {
        throw new Error(payload?.error || "Unable to submit application.");
      }

      setTutorJoinSuccess("Application submitted successfully.");
      setTutorJoinData({
        fullName: '',
        tutorType: 'Teacher',
        socialPlatform: 'Instagram',
        followersCount: '',
        whatsappPhone: '',
        email: '',
      });
    } catch (submitError) {
      setTutorJoinError(submitError?.message || "Unable to submit application.");
    } finally {
      setTutorJoinSubmitting(false);
    }
  };


  // ADD — stage -> available years (and reset dependents)
  React.useEffect(() => {
    if (schoolStage === 'ابتدائي') setAvailableYears(['1', '2', '3', '4', '5']);
    else if (schoolStage === 'متوسط') setAvailableYears(['1', '2', '3', '4']);
    else if (schoolStage === 'ثانوي') setAvailableYears(['1', '2', '3']);
    else setAvailableYears([]);

    setSchoolYear('');
    setHighStream('');
    setSubjectsChosen([]);
    setAvailableSubjects([]);
  }, [schoolStage]);

  // ✅ single source of truth for branches
  useEffect(() => {
    // clear whenever stage isn’t high school
    if (schoolStage !== 'ثانوي') {
      setAvailableHighBranches([]);
      setHighStream('');
      return;
    }

    // when high school, compute by year
    if (schoolYear === '1') {
      setAvailableHighBranches(['جذع مشترك آداب', 'جذع مشترك علوم وتكنولوجيا']);
    } else if (schoolYear === '2' || schoolYear === '3') {
      setAvailableHighBranches([
        'علوم تجريبية',
        'رياضيات',
        'تقني رياضي',
        'تسيير واقتصاد',
        'آداب وفلسفة',
        'لغات أجنبية',
      ]);
    } else {
      setAvailableHighBranches([]);
    }

    // reset chosen branch whenever year changes
    setHighStream('');
    setSubjectsChosen([]);
  }, [schoolStage, schoolYear]);


  // ADD — compute subjects for the selected academic level
  React.useEffect(() => {
    const lvl = computeAcademicLevelLabel();
    if (!lvl) {
      setAvailableSubjects([]);
      return;
    }
    setAvailableSubjects(SUBJECTS.filter((s) => s.level === lvl).map((s) => s.name));
    setSubjectsChosen([]);
  }, [computeAcademicLevelLabel]);

  const handleNavigate = (path) => {
    navigate(path);
  };


  const TeachingIcon = styled('img')(({ theme }) => ({
    width: '100%',
    height: 'auto',
  }));


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError('');

    setFieldErrors((prev) => {
      const next = { ...prev };
      if (name === 'firstName' && value.trim()) next.firstName = '';
      if (name === 'lastName'  && value.trim()) next.lastName  = '';
      if (name === 'email'     && emailRegex.test(value.trim()))  next.email     = '';
      if (name === 'phone'     && value.trim()) next.phone = '';
      return next;
    });
  };



  //. Submit student's info 
  const handleSubmit = async (e, overrides = {}) => {
    if (e?.preventDefault) e.preventDefault();

    try {
      setSubmitting(true);

      // take a stable snapshot that includes last-step fields
      const data = { ...formData, ...overrides };

      // ===== Basic validation =====
      if (!data.firstName?.trim() || !data.lastName?.trim()) {
        setError(t('الرجاء إدخال الاسم واللقب'));
        return false;
      }
      if (!emailRegex.test(data.email)) {
        setError(t('الرجاء إدخال البريد الإلكتروني الصحيح'));
        return false;
      }
      if (!data.phone?.trim()) {
        setError(t('الرجاء إدخال رقم الهاتف'));
        return false;
      }

      // ===== Modal-specific validation =====
      if (!data.program) {
        setError(t('يرجى اختيار نوع البرنامج أولاً.'));
        return false;
      }

      if (data.program === 'languages') {
        if (!langCategory || !language || !level) {
          setError(t('يرجى اختيار الفئة واللغة والمستوى.'));
          return false;
        }
      } else {
        const levelLabel = computeAcademicLevelLabel();
        if (!schoolStage || !levelLabel || !subjectsChosen.length) {
          setError(t('يرجى اختيار المرحلة/السنة/الشعبة (عند الحاجة) والمواد.'));
          return false;
        }
      }

      // ===== Payment validation =====
      if (!paymentMethod) {
        setError(t('يرجى اختيار طريقة الدفع.'));
        return false;
      }
      if (paymentMethod === 'ccp' && !paymentFile) {
        setError(t('يرجى رفع وصل الدفع الخاص بحساب CCP.'));
        return false;
      }

      // ===== Duplicate check (email / phone) =====
      const [emailSnapshot, phoneSnapshot] = await Promise.all([
        getDocs(query(collection(db, 'students'), where('email', '==', data.email.trim().toLowerCase()))),
        getDocs(query(collection(db, 'students'), where('phone', '==', data.phone))),
      ]);
      if (!emailSnapshot.empty || !phoneSnapshot.empty) {
        setError(t('لا يمكنك إعادة التسجيل. يرجى التوجه إلى الإدارة لتأكيد تسجيلك.'));
        return false;
      }

      // ===== Optional: upload CCP receipt =====
      let ccpReceiptUrl = null;
      if (paymentMethod === 'ccp' && paymentFile) {
        const ext = paymentFile.name?.split('.').pop() || 'bin';
        const path = `payments/${Date.now()}_${data.phone}.${ext}`;
        const fileRef = storageRef(storage, path);
        await uploadBytes(fileRef, paymentFile);
        ccpReceiptUrl = await getDownloadURL(fileRef);
      }

      // ===== Compute price =====
      const price = computePrice() || 0;

      // ===== Build enrollment payload =====
      const enrollment =
        data.program === 'languages'
          ? { program: 'languages', langCategory, language, level }
          : {
              program: 'subjects',
              schoolStage,
              schoolYear,
              highStream: highStream || '',
              subjectsChosen: [...subjectsChosen],
              academicLevelLabel: computeAcademicLevelLabel(),
            };

      const paymentInfo = {
        method: paymentMethod,
        ccpNumber: paymentMethod === 'ccp' ? ccpNumber : null,
        ccpReceiptUrl: paymentMethod === 'ccp' ? ccpReceiptUrl : null,
      };

      // ===== Persist to Firestore =====
      await addDoc(collection(db, 'students'), {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email.trim().toLowerCase(),
        phone: data.phone,
        enrollment,
        price,
        payment: paymentInfo,
        enrollments: [],
        adminValidated: false,
        fullyRegistered: false,
        entryDate: new Date().toISOString(),
        source: 'landing-modal',
      });

      setOpenSnackbar(true);

      // Reset fields (okay to reset before Step 4 since it's only a confirmation)
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        enrollments: [],
        adminValidated: false,
        fullyRegistered: false,
        entryDate: new Date().toISOString(),
      });
      setSelectedProgram(null);
      setLangCategory('');
      setLanguage('');
      setLevel('');
      setSchoolStage('');
      setSchoolYear('');
      setHighStream('');
      setSubjectsChosen([]);
      setPaymentMethod('');
      setPaymentFile(null);
      setError('');

      return true;
    } catch (err) {
      console.error('Error submitting form:', err);
      setError(t('حدث خطأ أثناء إرسال النموذج. يرجى المحاولة مرة أخرى.'));
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  

  useEffect(() => {
    const raf = requestAnimationFrame(() => setHeroEntered(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  useEffect(() => {
    if (offersInView) return;

    const sectionEl = benefitsRef.current;
    if (!sectionEl) return;

    if (typeof IntersectionObserver === 'undefined') {
      setOffersInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setOffersInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.22, rootMargin: '0px 0px -8% 0px' }
    );

    observer.observe(sectionEl);
    return () => observer.disconnect();
  }, [offersInView]);

  useEffect(() => {
    if (howInView) return;

    const sectionEl = howRef.current;
    if (!sectionEl) return;

    if (typeof IntersectionObserver === 'undefined') {
      setHowInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHowInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(sectionEl);
    return () => observer.disconnect();
  }, [howInView]);

  useEffect(() => {
    if (faqInView) return;

    const sectionEl = faqRef.current;
    if (!sectionEl) return;

    if (typeof IntersectionObserver === 'undefined') {
      setFaqInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setFaqInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(sectionEl);
    return () => observer.disconnect();
  }, [faqInView]);

  useEffect(() => {
    if (pricingInView) return;

    const sectionEl = pricingRef.current;
    if (!sectionEl) return;

    if (typeof IntersectionObserver === 'undefined') {
      setPricingInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPricingInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(sectionEl);
    return () => observer.disconnect();
  }, [pricingInView]);


  return (
    <div dir={pageDirection}>

    {/* ===== Hero section ===== */}
    <Box
      sx={{
        filter: (isFormModalOpen || isTutorJoinModalOpen) ? 'blur(4px)' : 'none',
        transition: 'filter .25s ease',
        pointerEvents: (isFormModalOpen || isTutorJoinModalOpen) ? 'none' : 'auto',
      }}
    >
      <Box
        sx={{
          background: '#ffffff',
          px: { xs: 1.5, sm: 2, md: 3 },
          pt: { xs: 2, md: 2.5 },
          fontFamily: '"Poppins","Segoe UI",sans-serif',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            width: 520,
            height: 520,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(147, 51, 234, 0.13), rgba(147,51,234,0))',
            left: '-120px',
            top: '-200px',
            pointerEvents: 'none',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: 520,
            height: 520,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(168,85,247,.12), rgba(168,85,247,0))',
            right: '-120px',
            bottom: '-230px',
            pointerEvents: 'none',
          }}
        />

        <Box sx={{ maxWidth: 1200, mx: 'auto', position: 'relative', zIndex: 1 }}>
          <Box
            sx={{
              border: '1px solid #ececf2',
              borderRadius: '999px',
              px: { xs: 1, md: 1.5 },
              py: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              backgroundColor: '#fff',
              boxShadow: '0 6px 20px rgba(15,23,42,0.04)',
              maxWidth: 860,
              mx: 'auto',
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ml: 2}}>
              <Box
                component="img"
                src={logo}
                alt={t('landing.brand')}
                sx={{ width: { xs: 105, md: 118 }, height: 'auto', display: 'block' }}
              />
            </Stack>
            <Stack direction="row" spacing={1} sx={{ display: { xs: 'none', md: 'flex' } }}>
              {heroNavItems.map((item) => (
                <Box
                  key={item.key}
                  component="button"
                  type="button"
                  onClick={() => handleHeroNavClick(item.key, item.targetId)}
                  sx={{
                    px: 1.6,
                    py: 0.7,
                    borderRadius: '999px',
                    fontSize: '0.9rem',
                    color: '#3f3f46',
                    bgcolor: activeHeroNav === item.key ? '#f4f4f5' : 'transparent',
                    fontWeight: activeHeroNav === item.key ? 600 : 500,
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'background-color .15s ease',
                    '&:hover': { bgcolor: '#f4f4f5' },
                  }}
                >
                  {item.label}
                </Box>
              ))}
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <IconButton
                aria-label="navigation"
                aria-controls="hero-nav-menu"
                aria-haspopup="true"
                onClick={handleNavMenuOpen}
                sx={{
                  display: { xs: 'inline-flex', md: 'none' },
                  width: 42,
                  height: 42,
                  borderRadius: '14px',
                  border: '1px solid #eef2f7',
                  bgcolor: '#ffffff',
                  '&:hover': { bgcolor: '#f8fafc' },
                }}
              >
                <MenuRoundedIcon sx={{ color: '#374151' }} />
              </IconButton>
              <Tooltip title={t(currentLang.labelKey)} arrow>
                <IconButton
                  aria-label="language"
                  aria-controls="hero-language-menu"
                  aria-haspopup="true"
                  onClick={handleLangMenuOpen}
                  sx={{
                    width: 42,
                    height: 42,
                    borderRadius: '14px',
                    border: '1px solid #eef2f7',
                    bgcolor: '#ffffff',
                    overflow: 'hidden',
                    p: 1,
                    '&:hover': { bgcolor: '#f8fafc' },
                  }}
                >
                  <Box
                    component="img"
                    src={currentLang.flagImg}
                    alt={t(currentLang.labelKey)}
                    sx={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
                  />
                </IconButton>
              </Tooltip>
            </Stack>
          </Box>
          <Menu
            id="hero-nav-menu"
            anchorEl={navAnchorEl}
            open={Boolean(navAnchorEl)}
            onClose={handleNavMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{
              paper: {
                sx: {
                  width: 220,
                  borderRadius: 3,
                  mt: 1,
                  boxShadow: "0 18px 45px rgba(0,0,0,0.12)",
                  border: "1px solid rgba(0,0,0,0.06)",
                  direction: pageDirection,
                },
              },
            }}
            MenuListProps={{ sx: { p: 0.7 } }}
          >
            {heroNavItems.map((item) => (
              <MenuItem
                key={item.key}
                onClick={() => handleHeroNavClick(item.key, item.targetId)}
                sx={{
                  borderRadius: 2,
                  px: 1.5,
                  py: 1,
                  fontWeight: activeHeroNav === item.key ? 700 : 500,
                  bgcolor: activeHeroNav === item.key ? "rgba(126,34,206,0.10)" : "transparent",
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Menu>
          <Menu
            id="hero-language-menu"
            anchorEl={langAnchorEl}
            open={Boolean(langAnchorEl)}
            onClose={handleLangMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{
              paper: {
                sx: {
                  width: 240,
                  borderRadius: 3,
                  overflow: "hidden",
                  mt: 1,
                  boxShadow: "0 18px 45px rgba(0,0,0,0.12)",
                  border: "1px solid rgba(0,0,0,0.06)",
                  direction: pageDirection,
                },
              },
            }}
            MenuListProps={{ sx: { p: 0.7 } }}
          >
            {LANGS.map((lng) => {
              const selected = (i18n.language || "ar") === lng.code;
              return (
                <MenuItem
                  key={lng.code}
                  onClick={() => handleSelectLanguage(lng.code)}
                  sx={{
                    borderRadius: 2,
                    alignItems: "center",
                    gap: 1.1,
                    px: 1.25,
                    py: 1,
                    "&:hover": { bgcolor: "#f9fafb" },
                    bgcolor: selected ? "rgba(126,34,206,0.10)" : "transparent",
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <Box component="img" src={lng.flagImg} alt={t(lng.labelKey)} sx={{ width: 23, height: 15, borderRadius: "4px", objectFit: "contain" }} />
                  </ListItemIcon>
                  <Box sx={{ fontSize: 13.5, fontWeight: 700, color: "#111827", minWidth: 0, flex: 1 }}>{t(lng.labelKey)}</Box>
                </MenuItem>
              );
            })}
          </Menu>

          <Stack
            alignItems="center"
            textAlign="center"
            sx={{ mt: { xs: 5, md: 7 }, position: 'relative', zIndex: 2 }}
          >

            <Typography
              sx={{
                mt: 3,
                fontSize: { xs: '2.15rem', md: '4.05rem' },
                lineHeight: { xs: 1.12, md: 1.05 },
                letterSpacing: '-0.03em',
                fontWeight: 700,
                color: '#09090b',
                maxWidth: 860,
                opacity: heroEntered ? 1 : 0,
                transform: heroEntered ? 'translateY(0)' : 'translateY(-28px)',
                transition: 'opacity 780ms ease-out, transform 900ms cubic-bezier(.16,1,.3,1)',
                '@media (prefers-reduced-motion: reduce)': {
                  opacity: 1,
                  transform: 'none',
                  transition: 'none',
                },
              }}
            >
              {t('landing.hero.title')}
            </Typography>

            <Typography
              sx={{
                mt: 2.1,
                maxWidth: 650,
                color: '#71717a',
                fontSize: { xs: '1rem', md: '1.2rem' },
                lineHeight: 1.55,
                opacity: heroEntered ? 1 : 0,
                transform: heroEntered ? 'translateY(0)' : 'translateY(-22px)',
                transition: 'opacity 740ms ease-out 180ms, transform 860ms cubic-bezier(.16,1,.3,1) 180ms',
                '@media (prefers-reduced-motion: reduce)': {
                  opacity: 1,
                  transform: 'none',
                  transition: 'none',
                },
              }}
            >
              {t('landing.hero.subtitle')}
            </Typography>

            <Button
              type="button"
              onClick={handleOpenTutorJoinCta}
              sx={{
                mt: 3.2,
                borderRadius: '999px',
                px: 3.2,
                py: 1.1,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.98rem',
                background: 'linear-gradient(135deg,#a855f7,#7e22ce)',
                color: '#fff',
                boxShadow: '0 12px 30px rgba(126,34,206,0.26)',
                opacity: heroEntered ? 1 : 0,
                transform: heroEntered ? 'translateY(0)' : 'translateY(-16px)',
                transition: 'opacity 680ms ease-out 300ms, transform 800ms cubic-bezier(.16,1,.3,1) 300ms',
                '&:hover': { background: 'linear-gradient(135deg,#9333ea,#6b21a8)' },
                '@media (prefers-reduced-motion: reduce)': {
                  opacity: 1,
                  transform: 'none',
                  transition: 'none',
                },
              }}
            >
              {t('landing.hero.cta')}
            </Button>

            <Typography
              sx={{
                mt: 2,
                color: '#a1a1aa',
                fontSize: '0.92rem',
                opacity: heroEntered ? 1 : 0,
                transform: heroEntered ? 'translateY(0)' : 'translateY(-10px)',
                transition: 'opacity 620ms ease-out 380ms, transform 720ms cubic-bezier(.16,1,.3,1) 380ms',
                '@media (prefers-reduced-motion: reduce)': {
                  opacity: 1,
                  transform: 'none',
                  transition: 'none',
                },
              }}
            >
              {t('landing.hero.note')}
            </Typography>
          </Stack>

          <Box
            sx={{
              maxWidth: 900,
              mx: 'auto',
              mt: { xs: -5, md: -10 },
              position: 'relative',
              zIndex: 1,
              pointerEvents: 'none',
              opacity: heroEntered ? 1 : 0,
              transform: heroEntered ? 'translateX(0)' : 'translateX(60px)',
              transition: 'opacity 900ms ease-out 200ms, transform 1100ms cubic-bezier(.16,1,.3,1) 200ms',
              '@media (prefers-reduced-motion: reduce)': {
                opacity: 1,
                transform: 'none',
                transition: 'none',
              },
            }}
          >
            <Box
              component="img"
              src={HeroImg}
              alt={t('landing.hero.imageAlt')}
              sx={{
                width: '100%',
                objectFit: 'cover',
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>

    {/* ===== WHAT DARSSY OFFERS ===== */}
    <Box
      id="benefits-section"
      ref={benefitsRef}
      sx={{
        backgroundColor: '#ffffffff',
        py: { xs: 3, md: 5 },
        px: { xs: 2, md: 3 },
      }}
    >
      <Box sx={{ maxWidth: 1120, mx: 'auto' }}>
        <Typography
          sx={{
            textAlign: 'center',
            fontSize: { xs: '2rem', md: '2.8rem' },
            fontWeight: 800,
            color: '#101828',
            letterSpacing: '-0.02em',
            opacity: offersInView ? 1 : 0,
            transform: offersInView ? 'translateY(0)' : 'translateY(24px)',
            transition: 'opacity 650ms ease-out, transform 800ms cubic-bezier(.16,1,.3,1)',
            '@media (prefers-reduced-motion: reduce)': {
              opacity: 1,
              transform: 'none',
              transition: 'none',
            },
          }}
        >
          {t('landing.offers.title')}
        </Typography>
        <Typography
          sx={{
            textAlign: 'center',
            mt: 1.2,
            mb: { xs: 3, md: 4.5 },
            color: '#6b7280',
            fontSize: { xs: '0.98rem', md: '1.1rem' },
            opacity: offersInView ? 1 : 0,
            transform: offersInView ? 'translateY(0)' : 'translateY(18px)',
            transition: 'opacity 620ms ease-out 130ms, transform 760ms cubic-bezier(.16,1,.3,1) 130ms',
            '@media (prefers-reduced-motion: reduce)': {
              opacity: 1,
              transform: 'none',
              transition: 'none',
            },
          }}
        >
          {t('landing.offers.subtitle')}
        </Typography>

        <Grid container columnSpacing={1.25} rowSpacing={6}>
          {[
            {
              title: t('landing.offers.items.studentManagement.title'),
              text: t('landing.offers.items.studentManagement.text'),
              icon: 'groups',
            },
            {
              title: t('landing.offers.items.liveLessons.title'),
              text: t('landing.offers.items.liveLessons.text'),
              icon: 'meetings',
            },
            {
              title: t('landing.offers.items.contentDelivery.title'),
              text: t('landing.offers.items.contentDelivery.text'),
              icon: 'content',
            },
            {
              title: t('landing.offers.items.messaging.title'),
              text: t('landing.offers.items.messaging.text'),
              icon: 'messages',
            },
            {
              title: t('landing.offers.items.payments.title'),
              text: t('landing.offers.items.payments.text'),
              icon: 'tracking',
            },
            {
              title: t('landing.offers.items.multilanguage.title'),
              text: t('landing.offers.items.multilanguage.text'),
              icon: 'languages',
            },
          ].map((offer, idx) => (
            <Grid item xs={12} sm={6} md={4} key={offer.title + idx}>
                <Paper
                  elevation={0}
                  sx={{
                  borderRadius: 4,
                  border: '1px solid #eceef4',
                  backgroundColor: '#fff',
                    p: 2.2,
                    height: '100%',
                    boxShadow: '0 6px 18px rgba(2,6,23,0.05)',
                    opacity: offersInView ? 1 : 0,
                    transform: offersInView ? 'translateY(0)' : 'translateY(28px)',
                    transition: `opacity 620ms ease-out ${220 + idx * 80}ms, transform 820ms cubic-bezier(.16,1,.3,1) ${220 + idx * 80}ms`,
                    '@media (prefers-reduced-motion: reduce)': {
                      opacity: 1,
                      transform: 'none',
                      transition: 'none',
                    },
                  }}
                >
                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: 2,
                      display: 'grid',
                      placeItems: 'center',
                      background: 'linear-gradient(135deg,#f5f3ff,#ede9fe)',
                      color: '#6d28d9',
                      flexShrink: 0,
                    }}
                  >
                    {offer.icon === 'groups' && <GroupsRoundedIcon sx={{ fontSize: 18 }} />}
                    {offer.icon === 'meetings' && <VideocamRoundedIcon sx={{ fontSize: 18 }} />}
                    {offer.icon === 'content' && <LibraryBooksRoundedIcon sx={{ fontSize: 18 }} />}
                    {offer.icon === 'messages' && <ForumRoundedIcon sx={{ fontSize: 18 }} />}
                    {offer.icon === 'tracking' && <InsightsRoundedIcon sx={{ fontSize: 18 }} />}
                    {offer.icon === 'languages' && <TranslateRoundedIcon sx={{ fontSize: 18 }} />}
                  </Box>
                  <Typography sx={{ fontWeight: 700, color: '#111827', fontSize: '1.04rem', lineHeight: 1.25 }}>
                    {offer.title}
                  </Typography>
                </Stack>
                <Typography sx={{ color: '#6b7280', fontSize: '0.95rem', lineHeight: 1.6, mb: 2.1 }}>
                  {offer.text}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>

    {/* ===== HOW IT WORKS ===== */}
    <Box
      id="how-section"
      ref={howRef}
      sx={{
        backgroundColor: '#ffffff',
        py: { xs: 6, md: 3 },
        px: { xs: 2, md: 3 },
      }}
    >
      <Box sx={{ maxWidth: 1120, mx: 'auto' }}>
        <Grid container spacing={{ xs: 4, md: 7 }} alignItems="center">
          <Grid item xs={12} md={5}>
            <Box
              component="img"
              src={HowItWorksImg}
              alt={t('landing.how.imageAlt')}
              sx={{
                width: '100%',
                maxWidth: 340,
                height: { xs: 470, md: 620 },
                objectFit: 'cover',
                borderRadius: 5,
                display: 'block',
                mx: 'auto',
                opacity: howInView ? 1 : 0,
                transform: howInView ? 'translateX(0)' : 'translateX(-36px)',
                transition: 'opacity 760ms ease-out, transform 920ms cubic-bezier(.16,1,.3,1)',
                '@media (prefers-reduced-motion: reduce)': {
                  opacity: 1,
                  transform: 'none',
                  transition: 'none',
                },
              }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={7}
            sx={{
              opacity: howInView ? 1 : 0,
              transform: howInView ? 'translateX(0)' : 'translateX(28px)',
              transition: 'opacity 760ms ease-out 120ms, transform 920ms cubic-bezier(.16,1,.3,1) 120ms',
              '@media (prefers-reduced-motion: reduce)': {
                opacity: 1,
                transform: 'none',
                transition: 'none',
              },
            }}
          >
            <Typography
              sx={{
                fontWeight: 800,
                color: '#111827',
                fontSize: { xs: '2rem', md: '2.8rem' },
                letterSpacing: '-0.02em',
                mb: 3.8,
                opacity: howInView ? 1 : 0,
                transform: howInView ? 'translateY(0)' : 'translateY(18px)',
                transition: 'opacity 620ms ease-out 180ms, transform 780ms cubic-bezier(.16,1,.3,1) 180ms',
                '@media (prefers-reduced-motion: reduce)': {
                  opacity: 1,
                  transform: 'none',
                  transition: 'none',
                },
              }}
            >
              {t('landing.how.title')}
            </Typography>

            <Box sx={{ position: 'relative', pl: { xs: 0.5, md: 1.5 } }}>
              <Box
                sx={{
                  position: 'absolute',
                  left: { xs: 18, md: 22 },
                  top: 8,
                  bottom: 8,
                  width: 2,
                  backgroundColor: '#ececf2',
                }}
              />

              <Stack spacing={4.4}>
                {[
                  {
                    title: t('landing.how.steps.1.title'),
                    text: t('landing.how.steps.1.text'),
                    icon: <PersonAddAlt1RoundedIcon sx={{ fontSize: 19 }} />,
                    active: true,
                  },
                  {
                    title: t('landing.how.steps.2.title'),
                    text: t('landing.how.steps.2.text'),
                    icon: <HowToRegRoundedIcon sx={{ fontSize: 19 }} />,
                    active: false,
                  },
                  {
                    title: t('landing.how.steps.3.title'),
                    text: t('landing.how.steps.3.text'),
                    icon: <SchoolRoundedIcon sx={{ fontSize: 19 }} />,
                    active: false,
                  },
                ].map((step, idx) => (
                  <Stack
                    key={step.title + idx}
                    direction="row"
                    spacing={2}
                    alignItems="flex-start"
                    sx={{
                      position: 'relative',
                      zIndex: 1,
                      opacity: howInView ? 1 : 0,
                      transform: howInView ? 'translateY(0)' : 'translateY(22px)',
                      transition: `opacity 620ms ease-out ${280 + idx * 120}ms, transform 780ms cubic-bezier(.16,1,.3,1) ${280 + idx * 120}ms`,
                      '@media (prefers-reduced-motion: reduce)': {
                        opacity: 1,
                        transform: 'none',
                        transition: 'none',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 38,
                        height: 38,
                        borderRadius: '999px',
                        display: 'grid',
                        placeItems: 'center',
                        background: step.active ? 'linear-gradient(135deg,#a855f7,#7e22ce)' : '#ffffff',
                        color: step.active ? '#fff' : '#8f95a3',
                        border: step.active ? 'none' : '2px solid #e6e8ef',
                        boxShadow: step.active ? '0 10px 20px rgba(126,34,206,0.26)' : 'none',
                        flexShrink: 0,
                      }}
                    >
                      {step.icon}
                    </Box>
                    <Box sx={{ pt: 0.2 }}>
                      <Typography sx={{ fontSize: '1.2rem', fontWeight: 700, color: '#111827', mb: 0.7 }}>
                        {step.title}
                      </Typography>
                      <Typography sx={{ fontSize: '0.98rem', lineHeight: 1.55, color: '#6b7280', maxWidth: 470 }}>
                        {step.text}
                      </Typography>
                    </Box>
                  </Stack>
                ))}
              </Stack>

              <Button
                type="button"
                onClick={handleOpenTutorJoinCta}
                sx={{
                  mt: 3,
                  borderRadius: '999px',
                  px: 3,
                  py: 1.1,
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  background: 'linear-gradient(135deg,#a855f7,#7e22ce)',
                  color: '#fff',
                  boxShadow: '0 12px 24px rgba(126,34,206,0.24)',
                  opacity: howInView ? 1 : 0,
                  transform: howInView ? 'translateY(0)' : 'translateY(16px)',
                  transition: 'opacity 620ms ease-out 700ms, transform 760ms cubic-bezier(.16,1,.3,1) 700ms',
                  '&:hover': { background: 'linear-gradient(135deg,#9333ea,#6b21a8)' },
                  '@media (prefers-reduced-motion: reduce)': {
                    opacity: 1,
                    transform: 'none',
                    transition: 'none',
                  },
                }}
              >
                {t('landing.how.cta')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>

    {/* ===== FAQ ===== */}
    <Box
      id="faq-section"
      ref={faqRef}
      sx={{
        backgroundColor: '#f6f7fb',
        py: { xs: 6, md: 9 },
        px: { xs: 2, md: 3 },
      }}
    >
      <Box sx={{ maxWidth: 1140, mx: 'auto' }}>
        <Grid container spacing={{ xs: 4, md: 6 }}>
          <Grid item xs={12} md={5}>
            <Typography
              sx={{
                fontSize: { xs: '2.4rem', md: '3rem' },
                lineHeight: 1.06,
                fontWeight: 800,
                color: '#111827',
                letterSpacing: '-0.03em',
                mb: 2.4,
                opacity: faqInView ? 1 : 0,
                transform: faqInView ? 'translateY(0)' : 'translateY(24px)',
                transition: 'opacity 700ms ease-out, transform 850ms cubic-bezier(.16,1,.3,1)',
                '@media (prefers-reduced-motion: reduce)': {
                  opacity: 1,
                  transform: 'none',
                  transition: 'none',
                },
              }}
            >
              {t('landing.faq.titleLine1')}
              <br />
              {t('landing.faq.titleLine2')}
            </Typography>

            <Typography
              sx={{
                color: '#6b7280',
                fontSize: { xs: '1rem', md: '1rem' },
                lineHeight: 1.65,
                maxWidth: 430,
                mb: 4,
                opacity: faqInView ? 1 : 0,
                transform: faqInView ? 'translateY(0)' : 'translateY(18px)',
                transition: 'opacity 640ms ease-out 120ms, transform 780ms cubic-bezier(.16,1,.3,1) 120ms',
                '@media (prefers-reduced-motion: reduce)': {
                  opacity: 1,
                  transform: 'none',
                  transition: 'none',
                },
              }}
            >
              {t('landing.faq.subtitle')}
            </Typography>
          </Grid>

          <Grid item xs={12} md={7}>
            <Box sx={{ borderTop: '1px solid #d2d8e2' }}>
              {[
                {
                  q: t('landing.faq.items.joining.question'),
                  a: t('landing.faq.items.joining.answer'),
                },
                {
                  q: t('landing.faq.items.fees.question'),
                  a: t('landing.faq.items.fees.answer'),
                },
                {
                  q: t('landing.faq.items.sessions.question'),
                  a: t('landing.faq.items.sessions.answer'),
                },
                {
                  q: t('landing.faq.items.start.question'),
                  a: t('landing.faq.items.start.answer'),
                },
              ].map((item, idx) => {
                const isOpen = activeFaq === idx;
                return (
                  <Box
                    key={item.q + idx}
                    sx={{
                      borderBottom: '1px solid #d2d8e2',
                      py: 2.1,
                      opacity: faqInView ? 1 : 0,
                      transform: faqInView ? 'translateY(0)' : 'translateY(26px)',
                      transition: `opacity 620ms ease-out ${180 + idx * 110}ms, transform 780ms cubic-bezier(.16,1,.3,1) ${180 + idx * 110}ms`,
                      '@media (prefers-reduced-motion: reduce)': {
                        opacity: 1,
                        transform: 'none',
                        transition: 'none',
                      },
                    }}
                  >
                    <Box
                      onClick={() => setActiveFaq(isOpen ? -1 : idx)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                        cursor: 'pointer',
                      }}
                    >
                      <Typography sx={{ fontSize: { xs: '1.2rem', md: '1.4rem' }, fontWeight: 700, color: '#1f2937', lineHeight: 1.3 }}>
                        {item.q}
                      </Typography>
                      <Typography sx={{ fontSize: '1.5rem', color: '#111827', minWidth: 22, textAlign: 'right' }}>
                        {isOpen ? '−' : '+'}
                      </Typography>
                    </Box>

                    {isOpen && (
                      <Typography sx={{ mt: 1.2, color: '#6b7280', fontSize: { xs: '1rem', md: '1.05rem' }, lineHeight: 1.65, pr: { md: 4 } }}>
                        {item.a}
                      </Typography>
                    )}
                  </Box>
                );
              })}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>

    {/* ===== PRICING ===== */}
    <Box
      id="pricing-section"
      ref={pricingRef}
      sx={{
        backgroundColor: '#f7f3fc',
        backgroundImage: {
          xs: 'linear-gradient(180deg, #f7f3fc 0%, #f2ebf9 100%)',
          md: `
            radial-gradient(130% 74% at 50% 44%, rgba(214,190,243,0.62) 0%, rgba(228,209,248,0.42) 34%, rgba(239,228,251,0.22) 60%, rgba(247,243,252,0.08) 78%, rgba(247,243,252,0) 100%),
            linear-gradient(180deg, #f8f5fd 0%, #f3edf9 52%, #f8f5fd 100%)
          `,
        },
        backgroundRepeat: 'no-repeat',
        py: { xs: 6, md: 6 },
        px: { xs: 2, md: 3 },
      }}
    >
      <Box sx={{ maxWidth: 1140, mx: 'auto' }}>
        <Stack alignItems="center" textAlign="center">
          <Typography
            sx={{
              fontSize: { xs: '2rem', md: '3rem' },
              fontWeight: 800,
              color: '#131325',
              letterSpacing: '-0.03em',
              opacity: pricingInView ? 1 : 0,
              transform: pricingInView ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 680ms ease-out, transform 820ms cubic-bezier(.16,1,.3,1)',
              '@media (prefers-reduced-motion: reduce)': {
                opacity: 1,
                transform: 'none',
                transition: 'none',
              },
            }}
          >
            Choose your right plan!
          </Typography>
          <Typography
            sx={{
              mt: 1,
              maxWidth: 650,
              color: '#6d6d7d',
              fontSize: { xs: '0.96rem', md: '1rem' },
              lineHeight: 1.6,
              opacity: pricingInView ? 1 : 0,
              transform: pricingInView ? 'translateY(0)' : 'translateY(16px)',
              transition: 'opacity 620ms ease-out 120ms, transform 760ms cubic-bezier(.16,1,.3,1) 120ms',
              '@media (prefers-reduced-motion: reduce)': {
                opacity: 1,
                transform: 'none',
                transition: 'none',
              },
            }}
          >
            Select from best plans, ensuring a perfect match. Need more or less? Customize your subscription for a seamless fit!
          </Typography>
        </Stack>

        <Box sx={{ mt: { xs: 1, md: 4 }, maxWidth: 1120, mx: 'auto' }}>
        <Grid
          container
          columnSpacing={{ xs: 0, md: 2.3 }}
          rowSpacing={{ xs: 5, md: 2.3 }}
          justifyContent="center"
          sx={{ width: '100%', m: 0 }}
        >
          {[
            {
              badge: 'Basic',
              description: 'This plan is for new tutors who want to test the platform before scaling.',
              price: 'FREE',
              suffix: '',
              features: [
                'Maximum 5 students',
                'Limited lessons',
                'Limited quizzes',
                'Core student management',
                'Core tutor-student messaging',
                'No custom features',
              ],
              cta: 'Get started',
              isCustom: false,
            },
            {
              badge: 'Pro Plus',
              description: 'Best for tutors with an influenced audience and warm clients. No limitations.',
              price: '20%',
              suffix: 'per student membership',
              features: [
                'Unlimited students',
                'Unlimited lessons and resources',
                'Unlimited quizzes and evaluations',
                'Live lessons and meeting management',
                'Messaging and communication tools',
                'Attendance and progress tracking',
                'Payments and billing support',
                'Multi-language platform support',
                'Custom features for tutors',
              ],
              cta: 'Get started',
              isCustom: false,
            },
            {
              badge: 'Enterprise',
              description: 'Designed for schools and educational establishments that need a management system to organize student education.',
              price: "Let's Talk",
              suffix: '',
              features: [
                'Everything included in Pro Plus',
                'Teacher, class, and group management at scale',
                'Academic planning and scheduling tools',
                'Parent, student, and staff communication flows',
                'Advanced analytics and performance dashboards',
                'Enterprise billing and finance workflows',
                'Role-based permissions and governance',
                'Dedicated onboarding, support, and customization',
              ],
              cta: 'Book a Call',
              isCustom: true,
            },
          ].map((plan, idx) => (
            <Grid
              key={plan.badge + idx}
              item
              xs={12}
              md={4}
              sx={{ mt: { xs: idx === 0 ? 0 : 1, md: 0 } }}
            >
              <Paper
                elevation={0}
                sx={{
                  borderRadius: 4,
                  border: plan.isCustom ? '1px solid #cfc2e6' : '1px solid #e5e7ef',
                  backgroundColor: plan.isCustom ? '#e8ddf8' : '#ffffff',
                  p: 2.4,
                  height: '100%',
                  boxShadow: '0 10px 24px rgba(31,41,55,0.05)',
                  display: 'flex',
                  flexDirection: 'column',
                  opacity: pricingInView ? 1 : 0,
                  transform: pricingInView ? 'translateY(0)' : 'translateY(24px)',
                  transition: `opacity 620ms ease-out ${180 + idx * 120}ms, transform 780ms cubic-bezier(.16,1,.3,1) ${180 + idx * 120}ms`,
                  '@media (prefers-reduced-motion: reduce)': {
                    opacity: 1,
                    transform: 'none',
                    transition: 'none',
                  },
                }}
              >
                <Box
                  sx={{
                    alignSelf: 'flex-start',
                    px: 1.2,
                    py: 0.5,
                    borderRadius: '999px',
                    fontSize: '0.8rem',
                    fontWeight: 700,
                    color: '#fff',
                    background: 'linear-gradient(135deg,#a855f7,#6d28d9)',
                    boxShadow: '0 8px 16px rgba(109,40,217,0.24)',
                    mb: 1.6,
                  }}
                >
                  {plan.badge}
                </Box>

                <Typography sx={{ color: '#6b7280', fontSize: '0.9rem', lineHeight: 1.6, minHeight: 86 }}>
                  {plan.description}
                </Typography>

                <Box sx={{ mt: 2.4, mb: 2 }}>
                  <Typography component="span" sx={{ fontSize: plan.isCustom ? '2.55rem' : '2.15rem', fontWeight: 800, color: '#111827', letterSpacing: '-0.02em' }}>
                    {plan.price}
                  </Typography>
                  {!!plan.suffix && (
                    <Typography component="span" sx={{ color: '#6b7280', fontSize: '0.92rem', ml: 0.6 }}>
                      {plan.suffix}
                    </Typography>
                  )}
                </Box>

                <Box sx={{ borderTop: '1px solid #d9deea', pt: 1.7, mb: 2, flex: 1 }}>
                  <Stack spacing={1.15}>
                    {plan.features.map((feature) => (
                      <Stack key={feature} direction="row" spacing={1} alignItems="center">
                        <CheckRoundedIcon sx={{ fontSize: 17, color: '#111827' }} />
                        <Typography sx={{ fontSize: '0.92rem', color: '#1f2937' }}>
                          {feature}
                        </Typography>
                      </Stack>
                    ))}
                  </Stack>
                </Box>

                <Button
                  fullWidth
                  type="button"
                  onClick={() => {
                    if ((plan.cta || '').toLowerCase() === 'get started') {
                      handleOpenTutorJoinCta();
                    }
                  }}
                  sx={{
                    borderRadius: 2.4,
                    textTransform: 'none',
                    fontWeight: 700,
                    py: 1.1,
                    border: plan.isCustom ? 'none' : '1px solid #dbe1ea',
                    color: plan.isCustom ? '#fff' : '#111827',
                    background: plan.isCustom ? 'linear-gradient(135deg,#2f2656,#1f1a3d)' : '#ffffff',
                    '&:hover': {
                      background: plan.isCustom ? 'linear-gradient(135deg,#2a214f,#181336)' : '#f9fafb',
                      borderColor: plan.isCustom ? 'transparent' : '#cfd6e2',
                    },
                  }}
                >
                  {plan.cta}
                </Button>
              </Paper>
            </Grid>
          ))}
        </Grid>
        </Box>
      </Box>
    </Box>

    <Dialog
      open={isTutorJoinModalOpen}
      onClose={closeTutorJoinModal}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: '0 24px 64px rgba(0,0,0,.25)',
          bgcolor: '#fcfcfd',
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0,0,0,0.45)',
            backdropFilter: 'blur(4px)',
          },
        },
      }}
    >
      <DialogContent sx={{ px: { xs: 2, md: 3 }, pb: 2.5, pt: 2.5 }}>
        <Stack alignItems="center" sx={{ mb: 2 }}>
          <Typography sx={{ mt: 1.4, fontSize: '1.85rem', lineHeight: 1.2, fontWeight: 800, color: '#111827', textAlign: 'center' }}>
            Join Darssy as a Tutor
          </Typography>
        </Stack>

        <Stack spacing={1.7}>
            <Box>
              <Typography sx={{ mb: 0.7, fontWeight: 700, color: '#1f2937', fontSize: '1.02rem' }}>
                Full Name
              </Typography>
              <TextField
                value={tutorJoinData.fullName}
                onChange={handleTutorJoinChange('fullName')}
                fullWidth
                placeholder="Enter your full name"
                variant="outlined"
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': { borderRadius: 2.2 },
                }}
              />
            </Box>

            <Box>
              <Typography sx={{ mb: 0.7, fontWeight: 700, color: '#1f2937', fontSize: '1.02rem' }}>
                Tutor Type
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  value={tutorJoinData.tutorType}
                  onChange={handleTutorJoinChange('tutorType')}
                  sx={{ borderRadius: 2.2 }}
                >
                  <MenuItem value="Teacher">Teacher</MenuItem>
                  <MenuItem value="Coach">Coach</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box>
              <Typography sx={{ mb: 0.7, fontWeight: 700, color: '#1f2937', fontSize: '1.02rem' }}>
                Social Media Platform Used for Tutoring
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  value={tutorJoinData.socialPlatform}
                  onChange={handleTutorJoinChange('socialPlatform')}
                  sx={{ borderRadius: 2.2 }}
                >
                  <MenuItem value="Instagram">Instagram</MenuItem>
                  <MenuItem value="TikTok">TikTok</MenuItem>
                  <MenuItem value="YouTube">YouTube</MenuItem>
                  <MenuItem value="Facebook">Facebook</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box>
              <Typography sx={{ mb: 0.7, fontWeight: 700, color: '#1f2937', fontSize: '1.02rem' }}>
                Total Number of Followers
              </Typography>
              <TextField
                value={tutorJoinData.followersCount}
                onChange={handleTutorJoinChange('followersCount')}
                fullWidth
                placeholder="Enter your follower count"
                type="number"
                variant="outlined"
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': { borderRadius: 2.2 },
                }}
              />
            </Box>

            <Box>
              <Typography sx={{ mb: 0.7, fontWeight: 700, color: '#1f2937', fontSize: '1.02rem' }}>
                WhatsApp Phone Number
              </Typography>
              <TextField
                value={tutorJoinData.whatsappPhone}
                onChange={handleTutorJoinChange('whatsappPhone')}
                fullWidth
                placeholder="+213550265689"
                variant="outlined"
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': { borderRadius: 2.2 },
                }}
              />
            </Box>

            <Box>
              <Typography sx={{ mb: 0.7, fontWeight: 700, color: '#1f2937', fontSize: '1.02rem' }}>
                Email Address
              </Typography>
              <TextField
                value={tutorJoinData.email}
                onChange={handleTutorJoinChange('email')}
                fullWidth
                placeholder="name@example.com"
                type="email"
                variant="outlined"
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': { borderRadius: 2.2 },
                }}
              />
            </Box>

            {tutorJoinError && (
              <Alert severity="error" sx={{ borderRadius: 2 }}>
                {tutorJoinError}
              </Alert>
            )}
            {tutorJoinSuccess && (
              <Alert severity="success" sx={{ borderRadius: 2 }}>
                {tutorJoinSuccess}
              </Alert>
            )}

            <Button
              fullWidth
              onClick={handleTutorJoinSubmit}
              disabled={tutorJoinSubmitting}
              sx={{
                mt: 0.6,
                borderRadius: '10px',
                py: 1.15,
                textTransform: 'none',
                fontWeight: 700,
                fontSize: '1.05rem',
                color: '#fff',
                background: 'linear-gradient(135deg,#7f7df4,#8f6bf3)',
                boxShadow: '0 10px 24px rgba(126,105,241,0.35)',
                '&:hover': { background: 'linear-gradient(135deg,#6d6bec,#7b57ec)' },
              }}
            >
              <Stack direction="row" spacing={1.1} alignItems="center">
                <Box component="span">
                  {tutorJoinSubmitting ? "Submitting..." : "Submit Application"}
                </Box>
              </Stack>
            </Button>
          </Stack>
      </DialogContent>
    </Dialog>

    {/* ===== Selector section between hero and form ===== */}
    {false && (<Box
      sx={{
        backgroundColor: '#fefefeff',        // deep, professional navy
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: { xs: 2, md: 4 },
        px: 2,
        textAlign: 'center',
        gap: 2.5,
      }}
    >
      <Typography
        sx={{
          fontWeight: 800,
          letterSpacing: '.3px',
          fontSize: '2.3rem',
        }}
      >
        {t('اِختر البرنامج الذي يناسبك')}
      </Typography>

      <Typography
        sx={{
          fontWeight: 400,
          color: 'text.secondary',
          fontSize: { xs: '1rem', sm: '1.2rem' },
          maxWidth: '600px',
          textAlign: 'center',
        }}
      >
        {t('اختر من بين برامجنا المتنوعة، سواء لدروس الدعم الأكاديمي أو لتطوير مستواك في اللغات الأجنبية')}
      </Typography>


      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid container spacing={3} sx={{ maxWidth: "1000px" }}>
          {/* Card 1 - Languages */}
          <Grid item xs={12} sm={6}>
            <Paper
              elevation={2}
              onClick={() => openFormModal('languages')}
              sx={{
                border: "1px solid #e5e7eb",
                borderRadius: 3,
                overflow: "hidden",
                height: "100%",
                cursor: "pointer",
                transition: "all 0.25s ease-in-out",
                "&:hover": {
                  boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                  transform: "translateY(-5px)",
                },
              }}
            >
              {/* Card image */}
              <Box
                component="img"
                src="https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=900&q=60"
                alt={t('Foreign Languages')}
                sx={{ width: "100%", height: 200, objectFit: "cover" }}
              />

              {/* Card content */}
              <Box sx={{ p: 3, display: "flex", gap: 2 }}>
                <Box
                  sx={{
                    width: "4px",
                    bgcolor: "black",
                    borderRadius: "2px",
                    flexShrink: 0,
                  }}
                />
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
                    {t('🇬🇧 🇫🇷 مستويات لغات أجنبية')}
                  </Typography>
                  <Typography variant="h6" color="text.secondary">
                    {t('تصفح دورات متعددة المستويات لتعلم اللغات الأجنبية')}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Card 2 - Academic Support */}
          <Grid item xs={12} sm={6}>
            <Paper
              elevation={2}
              onClick={() => openFormModal('support')} 
              sx={{
                border: "1px solid #e5e7eb",
                borderRadius: 3,
                overflow: "hidden",
                height: "100%",
                cursor: "pointer",
                transition: "all 0.25s ease-in-out",
                "&:hover": {
                  boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                  transform: "translateY(-5px)",
                },
              }}
            >
              {/* Card image */}
              <Box
                component="img"
                src= {ticket1}
                alt={t('Academic Support')}
                sx={{ width: "100%", height: 200, objectFit: "cover" }}
              />

              {/* Card content */}
              <Box sx={{ p: 3, display: "flex", gap: 2 }}>
                <Box
                  sx={{
                    width: "4px",
                    bgcolor: "black",
                    borderRadius: "2px",
                    flexShrink: 0,
                  }}
                />
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
                    {t('📚 دروس الدعم')}
                  </Typography>
                  <Typography variant="h6" color="text.secondary">
                    {t('استعرض برامج الدعم الأكاديمي لمختلف المستويات: الإبتدائي، المتوسط والثانوي')}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>)}


    {/* ===== FORM moved BELOW the image (normal flow) ===== */}
    {/* 
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        py: { xs: 4, md: 6 },
        px: { xs: 2, md: 0 },
        backgroundColor: '#f9fafb',
      }}
    >
      {/* Form Section */}
      {/* 
      <Paper
        elevation={3}
        sx={{
          width: { xs: '100%', sm: '80%', md: '55%' },
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.98)',
          direction: 'rtl',
        }}
      >
        <Typography variant="h3" align="center" gutterBottom>
          <b>أهلاً بكم في مدرسة هواري بومدين للغات</b>
        </Typography>

        <Typography variant="h6" align="center" gutterBottom>
            :الرجاء ملء الاستمارة الالكترونية أدناه للتسجيل معنا
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ width: '100%', maxWidth: 600 }}
        >
          <Grid container spacing={2}>
            {/* الاسم & اللقب side by side */}
            {/* 
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                name="firstName"
                label="الاسم"
                variant="standard"
                value={formData.firstName}
                onChange={handleChange}
                InputLabelProps={{
                  sx: {
                    direction: 'rtl',
                    textAlign: 'right',
                    right: 0,
                    left: 'auto',
                    transformOrigin: 'top right',
                  },
                }}
                inputProps={{
                  style: {
                    direction: 'rtl',
                    textAlign: 'right',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                name="lastName"
                label="اللقب"
                variant="standard"
                value={formData.lastName}
                onChange={handleChange}
                InputLabelProps={{
                  sx: {
                    direction: 'rtl',
                    textAlign: 'right',
                    right: 0,
                    left: 'auto',
                    transformOrigin: 'top right',
                  },
                }}
                inputProps={{
                  style: {
                    direction: 'rtl',
                    textAlign: 'right',
                  },
                }}
              />
            </Grid>

            {/* البريد الإلكتروني */}
            {/* 
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="email"
                label="البريد الإلكتروني"
                variant="standard"
                value={formData.email}
                onChange={handleChange}
                InputLabelProps={{
                  sx: {
                    direction: 'rtl',
                    textAlign: 'right',
                    right: 0,
                    left: 'auto',
                    transformOrigin: 'top right',
                  },
                }}
                inputProps={{
                  style: {
                    direction: 'rtl',
                    textAlign: 'right',
                  },
                }}
              />
            </Grid>

            {/* تأكيد البريد الإلكتروني 
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="confirmEmail"
                label="تأكيد البريد الإلكتروني"
                variant="standard"
                value={confirmEmail}
                onChange={(e) => setConfirmEmail(e.target.value)} 
                InputLabelProps={{
                  sx: {
                    direction: 'rtl',
                    textAlign: 'right',
                    right: 0,
                    left: 'auto',
                    transformOrigin: 'top right',
                  },
                }}
                inputProps={{
                  style: {
                    direction: 'rtl',
                    textAlign: 'right',
                  },
                }}
                onPaste={(e) => e.preventDefault()}
              />
            </Grid>
            */}

            {/* رقم الهاتف */}
            {/* 
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="phone"
                label="رقم الهاتف"
                variant="standard"
                value={formData.phone}
                onChange={handleChange}
                InputLabelProps={{
                  sx: {
                    direction: 'rtl',
                    textAlign: 'right',
                    right: 0,
                    left: 'auto',
                    transformOrigin: 'top right',
                  },
                }}
                inputProps={{
                  style: {
                    direction: 'rtl',
                    textAlign: 'right',
                  },
                }}
              />
            </Grid>
          </Grid>

          {error && (
            <Typography color="error" variant="body2" align="center" sx={{fontSize: '17px', marginTop: '20px'}}>
              {error}
              </Typography>
          )}
    
          
          {/* Snackbar for Success Message */}
          {/* 
          <Snackbar
            open={openSnackbar}
            autoHideDuration={6000}
            onClose={() => setOpenSnackbar(false)}
          >
            <Alert
              onClose={() => setOpenSnackbar(false)}
              severity="success"
              sx={{ width: '100%', fontSize: '18px' }}
            >
              شكراً على تقديم طلبك، يرجى التوجه إلى الإدارة لتأكيد تسجيلك
            </Alert>
          </Snackbar>
          
          {/* Centered Submit Button */}
          {/* 
          <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 3 }}>
            <Button
              variant="contained"
              color="success"
              sx={{ fontSize: '17px' }}
              type="submit"
              disabled={submitting} 
            >
              {submitting ? 'جاري الإرسال...' : 'إرسال النموذج'}
            </Button>
          </Box>

          {/* Link for already registered students */}
          {/* 
          <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
            <Typography variant="body2" sx={{ textAlign: 'center', fontSize: '16px' }}>
              إذا كنت مسجلًا مسبقًا، يمكنك 
              <Button
                variant="text"
                color="primary"
                onClick={() => handleNavigate('/student/login')}
                sx={{ fontSize: '16px', textDecoration: 'underline', padding: 0, marginLeft: '5px', marginRight: '5px' }}
              >
                تسجيل الدخول
              </Button>
              من هنا.
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>

    {/* ADD — modal form */}
    <Dialog
      open={isFormModalOpen}
      onClose={closeFormModal}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          direction: pageDirection,
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: '0 24px 64px rgba(0,0,0,.25)',
          bgcolor: '#fcfcfd'
        }
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0,0,0,0.45)',
            backdropFilter: 'blur(4px)'
          }
        }
      }}
    >
      {/* ——— Header ——— */}
      <Box
        sx={{
          px: 3,
          py: 2.5,
          color: '#fff',
          background: 'linear-gradient(135deg,#101010,#232323)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: '.2px' }}>
            {selectedProgram === 'languages'
              ? t('التسجيل في مستويات اللغات')
              : t('التسجيل في المواد الدراسية')}
          </Typography>
          <Typography variant="body2" sx={{ opacity: .85 }}>
            {t('تجربة تسجيل بسيطة ومُنظمة على أربع خطوات')}
          </Typography>
        </Box>
        <Typography sx={{ opacity: .9 }}>{t('الخطوة {{step}} من 4', { step })}</Typography>
      </Box>

      {/* ——— Progress ——— */}
      {step !== 4 && (
        <Box sx={{ px: { xs: 1, md: 3 }, pt: 2 }}>
          <Stepper
            alternativeLabel
            dir="ltr"                   // force LTR for consistent spacing
            activeStep={activeIndex}    // activate from the left after reversing
            sx={{
              width: '100%',
              '& .MuiStep-root': { flex: 1, minWidth: 0 },                 // equal width steps
              '& .MuiStepLabel-root': { width: '100%' },
              '& .MuiStepLabel-labelContainer': { width: '100%', textAlign: 'center' },
              '& .MuiStepLabel-label': { whiteSpace: 'nowrap', fontWeight: 700, mt: 1 },
              '& .MuiStepConnector-root': { top: 22 },
              '& .MuiStepConnector-line': { borderTopWidth: 2, borderColor: '#e3e6ea' },
              '& .MuiStepIcon-root': { color: '#2e7d32'  },                 // inactive
              '& .Mui-active .MuiStepIcon-root': { color: '#1976d2' },     // active
              '& .Mui-completed .MuiStepIcon-root': { color: '#bdbdbd'},  // completed
            }}
          >
            {[...steps].reverse().map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      )}


      {/* ——— Content ——— */}
      <DialogContent sx={{ px: 3, pb: 1, pt: 2 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2, direction: pageDirection }}>
            {error}
          </Alert>
        )}

        {/* ===== STEP 1 ===== */}
        {step === 1 && (
          <Box sx={{ display: 'grid', gap: 2.5, mt: 1 }}>
            {selectedProgram === 'languages' ? (
              <Grid container spacing={2.5}>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Typography sx={{ mb: .75, fontWeight: 700 }}>{t('الفئة')}</Typography>
                    <Select
                      value={langCategory}
                      onChange={(e) => setLangCategory(e.target.value)}
                      displayEmpty
                      sx={{
                        borderRadius: 2,
                        '& fieldset': { borderColor: '#d7dbe0' }
                      }}
                    >
                      <MenuItem value=""><em>{t('اختر الفئة')}</em></MenuItem>
                      <MenuItem value="أطفال">{t('👦 أطفال')}</MenuItem>
                      <MenuItem value="مراهقون">{t('👩‍🎓 مراهقون')}</MenuItem>
                      <MenuItem value="كبار">{t('👨 كبار')}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Typography sx={{ mb: .75, fontWeight: 700 }}>{t('اللغة')}</Typography>
                    <Select
                      value={language}
                      onChange={(e) => setLanguage(e.target.value)}
                      displayEmpty
                      sx={{ borderRadius: 2, '& fieldset': { borderColor: '#d7dbe0' } }}
                    >
                      <MenuItem value=""><em>{t('اختر اللغة')}</em></MenuItem>
                      {LANG_MODULES.map((l) => (
                        <MenuItem key={l} value={l}>{l}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Typography sx={{ mb: .75, fontWeight: 700 }}>{t('المستوى')}</Typography>
                    <Select
                      value={level}
                      onChange={(e) => setLevel(e.target.value)}
                      displayEmpty
                      sx={{ borderRadius: 2, '& fieldset': { borderColor: '#d7dbe0' } }}
                    >
                      <MenuItem value=""><em>{t('اختر المستوى')}</em></MenuItem>
                      {LANG_LEVELS.map((n) => (
                        <MenuItem key={n} value={String(n)}>
                          {n}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      borderColor: '#e6e9ee'
                    }}
                  >
                    <Typography sx={{ color: 'text.secondary' }}>
                      {t('لست متأكدًا من المستوى المناسب لك؟')}
                    </Typography>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => window.open('/placement-test', '_blank')}
                      sx={{ borderRadius: 999 }}
                    >
                      {t('اختبار تحديد المستوى')}
                    </Button>
                  </Paper>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={2.5}>
                {/* المرحلة */}
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Typography sx={{ mb: .75, fontWeight: 700 }}>{t('المرحلة')}</Typography>
                    <Select
                      value={schoolStage}
                      onChange={(e) => { setSchoolStage(e.target.value); setHighStream(''); }}
                      displayEmpty
                      sx={{ borderRadius: 2, '& fieldset': { borderColor: '#d7dbe0' } }}
                    >
                      <MenuItem value=""><em>{t('اختر المرحلة')}</em></MenuItem>
                      <MenuItem value="ابتدائي">{t('ابتدائي')}</MenuItem>
                      <MenuItem value="متوسط">{t('متوسط')}</MenuItem>
                      <MenuItem value="ثانوي">{t('ثانوي')}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* السنة الدراسية — place BEFORE الشعبة */}
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Typography sx={{ mb: .75, fontWeight: 700 }}>{t('السنة الدراسية')}</Typography>
                    <Select
                      value={schoolYear}
                      onChange={(e) => setSchoolYear(e.target.value)}
                      displayEmpty
                      sx={{ borderRadius: 2, '& fieldset': { borderColor: '#d7dbe0' } }}
                      disabled={!schoolStage}                   // block until stage is chosen
                    >
                      <MenuItem value=""><em>{t('اختر السنة')}</em></MenuItem>
                      {availableYears.map((y) => (
                        <MenuItem key={y} value={y}>{y}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* الشعبة — only for ثانوي, disabled until year is chosen */}
                {schoolStage === 'ثانوي' && (
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <Typography sx={{ mb: .75, fontWeight: 700 }}>{t('الشعبة')}</Typography>
                      <Select
                        value={highStream}
                        onChange={(e) => setHighStream(e.target.value)}
                        displayEmpty
                        sx={{ borderRadius: 2, '& fieldset': { borderColor: '#d7dbe0' } }}
                        disabled={!schoolYear}                  // ✅ must pick year first
                      >
                        <MenuItem value=""><em>{t('اختر الشعبة')}</em></MenuItem>
                        {availableHighBranches.map((b) => (
                          <MenuItem key={b} value={b}>{b}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                {/* المواد */}
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <Typography sx={{ mb: .75, fontWeight: 700 }}>{t('المواد')}</Typography>
                    <Select
                      multiple
                      value={subjectsChosen}
                      onChange={(e) => setSubjectsChosen(e.target.value)}
                      renderValue={(v) => (v.length ? v.join('، ') : t('اختر المواد'))}
                      sx={{ borderRadius: 2, '& fieldset': { borderColor: '#d7dbe0' } }}
                      disabled={!computeAcademicLevelLabel()}  
                    >
                      {availableSubjects.map((s) => (
                        <MenuItem key={s} value={s}>{s}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

            )}
          </Box>
        )}

        {/* ===== STEP 2 ===== */}
        {step === 2 && (
          <Box sx={{ mt: 1 }}>
            <Grid container spacing={2.5}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  label={t('الاسم')}
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  onBlur={validatePersonalStep}
                  error={Boolean(fieldErrors.firstName)}
                  helperText={fieldErrors.firstName}
                  InputProps={{ sx: { borderRadius: 2 } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  label={t('اللقب')}
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  onBlur={validatePersonalStep}
                  error={Boolean(fieldErrors.lastName)}
                  helperText={fieldErrors.lastName}
                  InputProps={{ sx: { borderRadius: 2 } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  label={t('البريد الإلكتروني')}
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={validatePersonalStep}
                  error={Boolean(fieldErrors.email)}
                  helperText={fieldErrors.email}
                  InputProps={{ sx: { borderRadius: 2 } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  label={t('رقم الهاتف')}
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  onBlur={validatePersonalStep}
                  error={Boolean(fieldErrors.phone)}
                  helperText={fieldErrors.phone}
                  InputProps={{ sx: { borderRadius: 2 } }}
                />
              </Grid>
            </Grid>

            {error && (
              <Typography color="error" align="center" sx={{ mt: 2 }}>
                {error}
              </Typography>
            )}
          </Box>
        )}


        {/* ===== STEP 3 ===== */}
        {step === 3 && (
          <Box sx={{ display: 'grid', gap: 2.5, mt: 1 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                borderRadius: 2,
                borderColor: '#e6e9ee',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography sx={{ fontWeight: 700 }}>
                {t('المبلغ المستحق: {{amount}} دج', { amount: computePrice() || 0 })}
              </Typography>
              <Typography color="text.secondary">
                {t('يُحدّد تلقائيًا حسب اختياراتك')}
              </Typography>
            </Paper>

            <FormControl fullWidth>
              <Typography sx={{ mb: .75, fontWeight: 700 }}>{t('طريقة الدفع')}</Typography>
              <Select
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
                displayEmpty
                sx={{ borderRadius: 2, '& fieldset': { borderColor: '#d7dbe0' } }}
              >
                <MenuItem value=""><em>{t('اختر طريقة الدفع')}</em></MenuItem>
                <MenuItem value="ccp">{t("CCP")}</MenuItem>
                <MenuItem value="cash">{t('نقدًا')}</MenuItem>
              </Select>
            </FormControl>

            {paymentMethod === 'ccp' && (
              <Box sx={{ display: 'grid', gap: 1.5 }}>
                <TextField
                  label={t('رقم الحساب CCP')} value={ccpNumber} InputProps={{ readOnly: true, sx: { borderRadius: 2 } }}
                  fullWidth
                />
                <Button variant="outlined" component="label" sx={{ borderRadius: 999, width: 'fit-content' }}>
                  {t('📤 رفع وصل الدفع')}
                  <input
                    type="file"
                    hidden
                    accept="image/*,.pdf"
                    onChange={(e) => setPaymentFile(e.target.files?.[0] || null)}
                  />
                </Button>
                {paymentFile && (
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    {t('تم اختيار: {{name}}', { name: paymentFile.name })}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        )}

        {/* ===== STEP 4 ===== */}
        {step === 4 && (
          <Box
            sx={{
              mt: { xs: 1, md: 2 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              gap: 2.5,
              py: { xs: 3, md: 5 },
            }}
          >
            {/* Badge + confetti */}
            <Box
              sx={{
                position: 'relative',
                width: 96,
                height: 96,
                mx: 'auto',
                borderRadius: '50%',
                display: 'grid',
                placeItems: 'center',
                bgcolor: '#66D17A',                // inner circle (green)
                // light green outer circle
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  inset: -22,                      // controls halo thickness
                  borderRadius: '50%',
                  bgcolor: 'rgba(102, 209, 122, 0.18)',
                },
                // subtle pop-in
                animation: 'popIn .35s ease-out',
                '@keyframes popIn': {
                  '0%':   { transform: 'scale(0.85)', opacity: 0 },
                  '100%': { transform: 'scale(1)',    opacity: 1 },
                },
              }}
            >
              <CheckRoundedIcon sx={{ fontSize: 40, color: '#fff' }} />
            </Box>

            {/* Titles */}
            <Box sx={{ direction: pageDirection }}>
              <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5 }}>
                {t('تم استلام طلبك بنجاح')}
              </Typography>
              <Typography sx={{ color: 'text.secondary', maxWidth: 520, mx: 'auto' }}>
                {t('شكرًا لتقديم طلبك. سنقوم بمراجعة بياناتك والتواصل معك قريبًا عبر البريد الإلكتروني أو الهاتف.')}
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>

      {/* ——— Sticky Action Bar ——— */}
      <DialogActions
        sx={{
          px: 3,
          py: 2,
          position: 'sticky',
          bottom: 0,
          backdropFilter: 'blur(6px)',
          background: 'linear-gradient(180deg, rgba(252,252,253,.9), rgba(252,252,253,.75))',
          borderTop: '1px solid #eef1f5'
        }}
      >
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
          <Button onClick={closeFormModal} color="inherit">{t('إلغاء')}</Button>

          {(() => {
            // ✅ Updated validity for Step 1
            const canNextStep1 =
              selectedProgram === 'languages'
                ? Boolean(langCategory && language && level)
                : (() => {
                    // For academic branch: must resolve to a concrete level AND pick at least one subject
                    const lvl = computeAcademicLevelLabel();
                    return Boolean(lvl && subjectsChosen.length);
                  })();

            if (step === 1) {
              return (
                <Button variant="contained" onClick={next} disabled={!canNextStep1}>
                  {t('التالي')}
                </Button>
              );
            }

            if (step === 2) {
              const canNextStep2 = () => validatePersonalStep();

              return (
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button onClick={back}>{t('السابق')}</Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      // run validation; only proceed if valid
                      if (canNextStep2()) next();
                      else setError(t('يرجى تصحيح الأخطاء في البيانات الشخصية قبل المتابعة.'));
                    }}
                  >
                    {t('التالي')}
                  </Button>
                </Box>
              );
            }

            if (step === 3) {
              return (
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button onClick={back}>{t('السابق')}</Button>
                  <Button
                    variant="contained"
                    disabled={!paymentMethod || (paymentMethod === 'ccp' && !paymentFile)}
                    onClick={async () => {
                      const overrides =
                        selectedProgram === 'languages'
                          ? { program: 'languages', langCategory, language, level }
                          : { program: 'subjects', schoolStage, highStream, schoolYear, subjectsChosen };

                      const ok = await handleSubmit(new Event('submit'), overrides);
                      if (ok) setStep(4);
                    }}
                  >
                    {t('تأكيد وإرسال')}
                  </Button>
                </Box>
              );
            }

            // step === 4
            return (
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => {
                    closeFormModal();
                    setStep(1);
                  }}
                >
                  {t('إغلاق')}
                </Button>
              </Box>
            );
          })()}
        </Box>
      </DialogActions>
    </Dialog>
    

    </div>
  );
}

export default LandingPage;
